import { Row, Col, Container, ButtonGroup, Spinner, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import Block from '../common/Display/Block';
import MenuNavBottom from '../common/MenuNavBottom';
import Translate, { t } from '../common/Translate';
import { useNrmRecordList } from '../../hooks/useNrmRecords/useNrmList';
import QuantityBadge from '../Form/QuantityBadge';
import RecordsResults from '../Form/RecordsResults';
import AutobizStrapPopup from '../common/Modal/AutobizStrapPopup';

function DashboardNrmRecords(props) {
  const {
    tabs,
    refresh,
    currentPage,
    pageCount,
    goToPage,
    records,
    error,
    currentTab,
    loading,
    filters,
    setSort,
    sort,
  } = useNrmRecordList(props);

  return (
    <Block noBack>
      <AutobizStrapPopup />
      <h1 className="page-title">
        <span className="cursor-pointer">
          <FontAwesomeIcon icon={faAward} size="1x" /> {t('dashboardNrm')}
        </span>
        <button type="button" onClick={refresh} className={`btn refresh-button btn-3 ${loading ? 'loading' : ''}`}>
          {loading && <Spinner size="sm" className="spinner-loader" />}
          <Translate code="refresh" />
        </button>
      </h1>
      <div className="filters-results-container">
        <Container fluid>
          <Row>
            <Col xs="12" className="switch-dashboard">
              <ButtonGroup className="d-block">
                {tabs.map(({ selected, onClick, count, name, type }) => (
                  <Button data-testid={`${type}Tab`} onClick={onClick} key={type} color="primary" outline={!selected}>
                    {name}
                    <QuantityBadge count={count} />
                  </Button>
                ))}
              </ButtonGroup>
            </Col>
          </Row>
          <Row>
            <RecordsResults
              currentPage={currentPage}
              pageNumbers={pageCount}
              loading={loading}
              changePaginationIndex={goToPage}
              forms={records}
              error={error}
              origin="dashboardNrm"
              currentTab={currentTab}
              tableFilters={filters}
              setSort={setSort}
              sort={sort}
            />
          </Row>
        </Container>
      </div>
      <MenuNavBottom active="dashboardNrm" />
    </Block>
  );
}

export default DashboardNrmRecords;
